import type { Components, Theme } from '@mui/material/styles';

export const typographyTheme: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    variantMapping: {
      headingXxLarge: 'h1',
      headingXLarge: 'h2',
      headingLarge: 'h3',
      headingMedium: 'h4',
      bodyLarge: 'p',
      bodyMedium: 'p',
      bodySmall: 'p',
      bodyXSmall: 'p'
    }
  },
  styleOverrides: {
    body1: ({ theme }) => ({
      color: theme.vars.palette.semantic.text.caption,
      fontSize: '1.125rem'
    }),
    body2: ({ theme }) => ({
      color: theme.vars.palette.semantic.text.caption
    }),
    h2: {
      fontSize: '1.75rem',
      fontWeight: 500
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.375rem'
    },
    h6: ({ theme }) => ({
      fontSize: '1.2rem',
      color: theme.vars.palette.semantic.text.primary
    })
  }
};
